<template>
  <div class="complain-container">
    <HeaderO title="车船详情"></HeaderO>
    <div class="main-containe">
      <!-- <div class="title">运输方式及所属公司信息</div> -->
      <van-cell-group>
        <van-field
            v-model="Datadetail.transportType"
            readonly
            label="车船类型"
        />
        <van-field
            v-model="Datadetail.vehiclesType"
            readonly
            label="车型"
        />
        <!-- <div class="title">营业执照信息</div> -->

        <van-field
            v-model="Datadetail.transportNumber"
            readonly
            label="车船号"
        />
        <van-field
            v-model="Datadetail.carrierId"
            readonly
            label="承运商"
        />
        <van-field
            v-model="Datadetail.transportWeight"
            readonly
            label="车辆自重"
        />
        <van-field
            v-model="Datadetail.goodsType"
            readonly
            label="货物类型"
        />
        <van-field
            v-model="Datadetail.approvedLoad"
            readonly
            label="核定载重"
        />
        <van-field
            v-model="Datadetail.loadTons"
            readonly
            label="车货最大总量"
        />
        <van-field
            v-model="Datadetail.transExpire"
            readonly
            label="道路运输经营许可号"
        />
        <van-field
            v-model="Datadetail.drivingLicenseDate"
            readonly
            label="行驶证有效期"
        />
        <van-field
            v-model="Datadetail.transportLicenseDate"
            readonly
            label="道路运输经营许可证有效期"
        />
        <van-field
            v-model="Datadetail.tractorProduceDate"
            readonly
            label="车辆制造有限期"
        />
        <van-field
            v-model="Datadetail.axesNum"
            readonly
            label="车辆轴数"
        />
        <van-field
            v-model="Datadetail.transportCompanyName"
            readonly
            label="运输公司名称"
        />
        <van-field
            v-model="Datadetail.loadProduct"
            readonly
            label="装载货品"
        />






        <div class="title">文件附件</div>

        <van-field
            :value="new Date(Datadetail.socialCreditCodeExpireDate).toLocaleString()"
            readonly
            label="社会信用代码有效期："
        />
        <van-field
            :value="new Date(Datadetail.transportLicenseExpireDate).toLocaleString()"
            readonly
            label="道路运输许可证有效期："
        />

      </van-cell-group>


    </div>
  </div>

</template>
  <script>
  import HeaderO from "@/components/HeaderO.vue";
  import transactionApi from "@/request/transactionApi";
  export default {
    name: "ComplaintList",
    components: {
      HeaderO,
    },
    data() {
      return {
        Datadetail: {},
        complaintStatus: "",
        unitList: [
          { value: "抚顺石化" },
          { value: "吉林石化" },
          { value: "兰州石化" },
        ],
        unitLists: [{ value: "低密度聚乙烯PE" }],
        flag: false,
        flags: false,
        editFlag: false,
        buyersetName: "", //买家结案文件名
        buyersetUrl: "", //买家结案地址
      };
    },
    computed: {
      complaintType() {
          let complaintType ="";
          switch (this.Datadetail.transportType) {
            case "01":
              complaintType = "公路";
              break;
            case "02":
              complaintType = "水路";
              break;
          }
          return complaintType;
      }, 
      
      statusName() {
        let statusName ="";
          switch (this.Datadetail.complaintStatus) {
            case "01":
              statusName = "已保存";
              break;
            case "02":
              statusName = "待处理";
              break;
            case "03":
              statusName = "已答复";
              break;
            case "04":
              statusName = "处理中";
              break;
            case "05":
              statusName = "已处理";
              break;
            case "06":
              statusName = "待审核";
              break;
  
            case "07":
              statusName = "已撤销";
              break;
            case "08":
              statusName = "审核拒绝";
              break;
            case "09":
              statusName = "已解决";
              break;
            case "10":
              statusName = "已结案";
              break;
          }
          return statusName;
      }
    },
    mounted() {
      // this.getlist();
      this.complaintStatus = this.$route.query.status;
      this.getList();
    },
    methods: {
      getList() {
        let companyComplaintId = this.$route.query.id;
        transactionApi.getCarDetail({ transportId:companyComplaintId }).then((res) => {
          if (res.returnCode == "0") {
            this.Datadetail = res.result;
            this.Datadetail.tractorProduceDate=new Date(res.result.tractorProduceDate).toLocaleString({ hour12:false},'chinese').replace(/(\/)/g,'-');
            this.Datadetail.drivingLicenseDate=new Date(res.result.drivingLicenseDate).toLocaleString({ hour12:false},'chinese').replace(/(\/)/g,'-');
            this.Datadetail.transportLicenseDate=new Date(res.result.transportLicenseDate).toLocaleString({ hour12:false},'chinese').replace(/(\/)/g,'-');
            this.Datadetail.transportType= (this.Datadetail.transportType=='10'&&'单车') || (this.Datadetail.transportType=='20'&&'挂车') || (this.Datadetail.transportType=='30'&&'牵引车') || (this.Datadetail.transportType=='40'&&'船')//车船类型（10单车20挂车30牵引40船)
            this.Datadetail.goodsType=(this.Datadetail.goodsType=='10'&&'公路') || (this.Datadetail.goodsType=='20'&&'水路') 
            

          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
  
          }
        });
      },
      Typelist(val) {
        let obj = {
          "01": "产品质量投诉",
          "02": "产品计量投诉",
          "03": "运输批次投诉",
          "04": "包装破损投诉",
          "05": "退货申请",
          "06": "其他投诉",
        };
        return obj[val];
      },
    },
  };
  </script>
<style lang="stylus" scoped>
.complain-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-containe {
  flex: 1;
  height: 85vh;
  position: absolute;
  padding: 0 20px;
  top: 0.88rem;
  left: 0;
  right: 0;
  // bottom: 0.88rem;
  font-size: 28px;
  overflow: auto;
}

.red {
  color: #ee0a24;
  font-size: 0.14rem;
}

.complain-container >>> .van-cell-group {
  background-color: #f6f4f5;
}

.complain-container >>> .van-field__label {
  width: 180px;
  font-size: 26px;
}

.complain-dropdown-menu >>> .van-cell {
  line-height: 50px;
}

.complain-container >>> .van-cell--required::before {
  left: 20px;
}

.complain-container >>> .van-popup {
  max-width: 95%;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title {
  line-height: 50px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__bar {
  border: 1px solid #666;
  background: #F4F4F4;
  border-radius: 10px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title::after {
  border: 10px solid;
  border-color: transparent transparent #dcdee0 #dcdee0;
  right: -20px;
  margin-top: -14px;
}

.complain-container .order-code >>> .van-cell.van-cell--clickable {
  padding: 0 30px 0 0;
  line-height: 50px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__title.van-field__label {
  padding-left: 28px;
}

.complain-container .order-code >>> .van-cell__title {
}

.complain-container .order-code >>> .van-cell.van-field {
  padding: 20px 0 20px 0;
}

.complain-container .van-cell-group >>> .van-cell {
  line-height: 50px;
  padding: 20px 30px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__right-icon {
  margin-left: 0.04rem;
  color: #969799;
  line-height: 50px;
  font-size: 30px;
  vertical-align: middle;
}

.complain-container {
  .title {
    font-size: 30px;
    height: 50px;
    line-height: 50px;
    padding: 20px 30px;
  }

  .file {
    min-height: 200px;
    background: #fff;
    padding: 20px 30px;
  }

  .complain-dropdown-menu {
    background: #fff;
    line-height: 50px;
    // padding: 20px 30px;
    margin-top: 10px;

    label {
      display: inline-block;
      width: 180px;
      font-size: 26px;
      padding-left: 20px;
    }

    .van-dropdown-menu {
      display: inline-block;
      padding: 20px 30px 20px 0;
      line-height: 50px;
      vertical-align: middle;
      width: calc(100% - 250px);
    }
  }
}

.btn-order {
  position: absolute;
  bottom: 2px;
  width: 100%;
  background: #fff;

  span {
    text-align: center;
    display: inline-block;
    width: 35%;
  }

  .card-btn {
    text-align: center;
    height: 100px;
    line-height: 100px;

    .btn {
      width: 90%;
      height: 80px;
      text-align: center;
      background: linear-gradient(132deg, #EF9623 0%, #E12020 100%);
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>